import { HttpClient } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { TranslateCompiler, TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import packageJson from '@root/package.json';

const createTranslateLoader = (http: HttpClient) => {
    let suffix = '?v=' + packageJson.version;
    if (isDevMode()) {
        suffix += '&t=' + new Date().getTime();
    }
    return new TranslateHttpLoader(http, './assets/i18n/', '.json' + suffix);
};

export const ngxTranslateConfig: TranslateModuleConfig = {
    loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader,
    },
    compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
    },
};
